import styled, {css} from "styled-components";
import {Animations, Styles} from "../Styles/Styles";
import {Colors} from "../Styles/Colors";
import {MdOutlineMailOutline} from "react-icons/md";
import {BiSolidBatteryLow} from "react-icons/bi";
import {RiRadarLine} from "react-icons/ri";
import useGlobalSettings from "../Provider/useGlobalSettings";
import {ViewTypes} from "../Provider/useGlobalSettingsContextProvider";
import {ComponentType} from "react";
import {IconBaseProps} from "react-icons";
import {SiCommodore} from "react-icons/si";
import {useNavigate} from "react-router-dom";

const Styles__ = {
    TopLine: styled.div`
        position: absolute;
        top: 0;
        width: 100%;
        height: 3px;
        background-color: ${ Colors.raw.neon_orange };
        overflow: hidden;
    `,
    ColorDiv: styled.div<{ pos: 'left' | 'right' }>`
        height: 20%;
        width: 20%;
        position: absolute;
        top: 0;
        left: ${ p => p.pos === 'left' ? '0' : undefined };
        right: ${ p => p.pos === 'right' ? '0' : undefined };
        background-color: ${ Colors.raw.neon_orange };
    `,
    SquareRotated: styled.div<{ pos: 'left' | 'right' }>`
        width: 25px;
        height: 24px;
        background-color: ${ Colors.raw.neon_orange };
        transform: rotate(45deg);
        position: absolute;
        top: -13px;
        left: ${ p => p.pos === 'left' ? 'calc(20% - 13px)' : undefined };
        right: ${ p => p.pos === 'right' ? 'calc(20% - 13px)' : undefined };
    `,
    Content: styled.div`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        height: 100%;
        justify-items: center;
        &:nth-child(2) {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
        }
    `,
    Footer: {
        Left: styled.div`
            width: 100%;
            height: 100%;
            align-items: center;
            display: flex;
            div {
                font-size: x-large;
                padding-left: 30px;
                text-align: left;
                color: white;
            }
        `,
        Middle: styled.div`
            display: flex;
            gap: 2px;
        `,
        Right: styled.div`
            width: 100%;
            height: 100%;
            align-items: center;
            display: flex;
            justify-items: flex-end;
            direction: rtl;
            padding-right: 50px;
            gap: 20px;
            * {
                width: 30px;
                height: 30px;
            }
        `,
        Mission: {
            Button: styled.div`
                position: relative;
                width: 85px;
                height: 100%;
                padding: 0;
                background-color: ${Colors.raw.terminal_orange};
                border: none;
                margin-top: 3px;
                color: ${Colors.raw.terminal_light};
                cursor: pointer;
            `,
            Text: styled.div`
                height: min-content;
                font-size: smaller;
            `,
            LowerStyleLine: styled.div`
                position: absolute;
                bottom: 0;
                background-color: ${Colors.raw.terminal_white};
                height: 6px;
                width: 100%;
            `,
            Symbol: styled(SiCommodore as ComponentType<IconBaseProps>)<{ $isNew: boolean }>`
                margin-top: 10px;
                width: 40px;
                height: 35px;
                color: ${p => p.$isNew ? Colors.raw.neon_orange : Colors.raw.terminal_light};
                opacity: ${p => p.$isNew ? 1 : 0.5};

                ${p => p.$isNew && css`
                    animation: ${Animations.blinking} 1.5s infinite ease-in-out;
                `}                
            `
        },
        EMail: {
            Button: styled.div`
                position: relative;
                width: 85px;
                height: 100%;
                padding: 0;
                background-color: ${Colors.raw.terminal_orange};
                border: none;
                margin-top: 3px;
                color: ${Colors.raw.terminal_light};
                cursor: pointer;
            `,
            Text: styled.div`
                height: min-content;
                font-size: smaller;
            `,
            LowerStyleLine: styled.div`
                position: absolute;
                bottom: 0;
                background-color: ${Colors.raw.terminal_white};
                height: 6px;
                width: 100%;
            `,
            Symbol: styled(MdOutlineMailOutline as ComponentType<IconBaseProps>)<{ $isNew: boolean }>`
                margin-top: 10px;
                width: 40px;
                height: 35px;
                color: ${p => p.$isNew ? Colors.raw.neon_orange : Colors.raw.terminal_light};
                opacity: ${p => p.$isNew ? 1 : 0.5};

                ${p => p.$isNew && css`
                    animation: ${Animations.blinking} 1.5s infinite ease-in-out;
                `}                
            `
        },
        Icons: {
            Battery: styled(BiSolidBatteryLow as ComponentType<IconBaseProps>)``,
            Radar: styled(RiRadarLine as ComponentType<IconBaseProps>)<{ $isFetching: boolean }>`
                color: ${p => p.$isFetching ? Colors.raw.neon_orange : Colors.raw.terminal_light};
                opacity: ${p => p.$isFetching ? 1 : 0.5};

                ${p => p.$isFetching && css`
                    animation: ${Animations.blinking} .2s infinite ease-in-out;
                `}
            `,
        }
    }
}

export const Footer = () => {

    const navigate = useNavigate()
    const { isFetching, Actions, Mails, activeMission } = useGlobalSettings();

    const handles = {
        backToList: () => {
            void navigate('/mail')
            // Actions.setViewTo( ViewTypes.ListOfEmails )
        },
        goToMissions: () => {},
    }

    return <Styles.DataPad.Footer.Frame id={'DataPad-Footer'}>
        <Styles__.TopLine />
        <Styles__.ColorDiv pos={'left'}/>
        <Styles__.SquareRotated pos={'left'}/>
        <Styles__.ColorDiv pos={'right'}/>
        <Styles__.SquareRotated pos={'right'}/>

        <Styles__.Content >
            <Styles__.Footer.Left>
                <div>DatenPad</div>
            </Styles__.Footer.Left>
            <Styles__.Footer.Middle>
                <Styles__.Footer.EMail.Button onClick={ handles.backToList }>
                    <Styles__.Footer.EMail.Symbol $isNew={ Mails.new } />
                    <Styles__.Footer.EMail.Text>E-Mail</Styles__.Footer.EMail.Text>
                    <Styles__.Footer.EMail.LowerStyleLine />
                </Styles__.Footer.EMail.Button>
                { false && activeMission &&
                    <Styles__.Footer.EMail.Button onClick={ handles.goToMissions }>
                        <Styles__.Footer.Mission.Symbol $isNew={ false } />
                        <Styles__.Footer.Mission.Text>Mission</Styles__.Footer.Mission.Text>
                        <Styles__.Footer.Mission.LowerStyleLine />
                    </Styles__.Footer.EMail.Button>
                }
            </Styles__.Footer.Middle>
            <Styles__.Footer.Right>
                <Styles__.Footer.Icons.Battery />
                <Styles__.Footer.Icons.Radar $isFetching={ isFetching } />
            </Styles__.Footer.Right>
        </Styles__.Content>

    </Styles.DataPad.Footer.Frame>;
}